/**
 * Open global pricing modal with consistent GA4 context (source, calculator_tier).
 */
export function normalizePricingContext(context = {}) {
  const source = context.source || context.ctaSource || context.utm_source || 'in_app_unknown';
  const calculatorTier = context.calculatorTier || context.calculator_tier || context.calculator || 'unknown';
  const surface = context.surface || 'pricing_modal';
  const pricingView = context.pricingView || context.pricing_view || 'simple';

  return {
    ...context,
    source,
    calculatorTier,
    surface,
    pricingView
  };
}

export function openPricingModal({
  source = 'in_app_unknown',
  calculatorTier = 'unknown',
  surface = 'pricing_modal',
  pricingView = 'simple'
} = {}) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(
    new CustomEvent('showPricingModal', {
      detail: normalizePricingContext({ source, calculatorTier, surface, pricingView })
    })
  );
}
